import React, { useState } from "react";
import theme from "../../../styles/theme";

const HeaderTabs = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div style={{ display: "flex", gap: theme.spacing.sm }}>
      {tabs.map((tab, index) => {
        const isActive = activeTab === index;

        return (
          <div
            key={index}
            onClick={() => setActiveTab(index)}
            style={{
              padding: `${theme.spacing.vs}px ${theme.spacing.md}px`,
              cursor: "pointer",
              fontFamily: theme.fonts.body,
              fontSize: theme.fontSizes.sm,
              fontWeight: theme.fontWeights.medium,
              color: isActive
                ? theme.colors.text.surface
                : theme.colors.text.body,
              background: isActive
                ? theme.colors.background.selected
                : "transparent",
              borderTopLeftRadius: "0px",
              borderBottomLeftRadius: "0px",
              borderTopRightRadius: "8px",
              borderBottomRightRadius: "8px",
              border: isActive
                ? `1px solid ${theme.colors.text.primary}`
                : "1px solid transparent",
              boxShadow: isActive
                ? `0 1px 3px rgba(0,0,0,0.1)`
                : "0 0 0 rgba(0,0,0,0)",
              transition: "all 0.2s ease",
              display: "flex",
              alignItems: "center",
            }}
            onMouseEnter={(e) => {
              if (!isActive) {
                e.currentTarget.style.background = theme.colors.background.hover;
                e.currentTarget.style.color = theme.colors.text.primary;
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive) {
                e.currentTarget.style.background = "transparent";
                e.currentTarget.style.color = theme.colors.text.body;
              }
            }}
          >
            {tab.label}
          </div>
        );
      })}
    </div>
  );
};

export default HeaderTabs;
